<template>
  <div>
    <div class="superuser-importsearch__top">
      <validation-observer
        ref="superuserImportSearchForm"
        tag="form"
        class="superuser-importsearch__form"
        @submit.prevent
        @keyup.enter="searchCustomer()">
        <validation-provider
          v-slot="{errors}"
          vid="customerId"
          rules="required"
          slim>
          <oie-base-input
            id="customerId"
            v-model="query"
            :label-text="`${t('superuserImportSearchLabel')}*`"
            :error-messages="errors"
            class="superuser-importsearch__input"></oie-base-input>
        </validation-provider>

        <oie-base-button
          v-element-loader="{ endpoint: 'superuser/import/search' }"
          css-classes="button--with-border button--blue superuser-importsearch__action"
          :text="t('superuserImportSearchButtonLabel')"
          @click="searchCustomer()"></oie-base-button>
      </validation-observer>
    </div>

    <div v-if="erpCustomer && erpCustomer.hasEmail && erpCustomer.hasMobile">
      <h3>{{ t('superuserImportFoundErpCustomerHeader') }}</h3>

      <validation-observer
        ref="superuserImportForm"
        tag="form">
        <div class="superuser-import-info__container">
          <div class="superuser-import-form__block-content">
            <oie-base-input
              v-model="erpCustomer.name"
              :label-text="t('superuserCustomerNameLabel')"
              :is-readonly="true"
              class="superuser-import__input-wide"></oie-base-input>
          </div>
          <validation-provider
            v-slot="{errors}"
            rules="required"
            slim>
            <div class="superuser-import-form__block-content">
              <oie-base-input
                v-model="erpCustomer.firstName"
                :label-text="tStatic('firstNameLabel')"
                :error-messages="errors"
                class="superuser-import__input-wide"></oie-base-input>
            </div>
            <div class="superuser-import-form__block-content">
              <oie-base-input
                v-model="erpCustomer.lastName"
                :label-text="tStatic('lastNameLabel')"
                :error-messages="errors"
                class="superuser-import__input-wide"></oie-base-input>
            </div>
          </validation-provider>

          <div class="superuser-import-form__block-content">
            <oie-base-input
              v-model="erpCustomer.email"
              :label-text="t('superuserImportEmailLabel')"
              :is-readonly="true"
              class="superuser-import__input-wide"></oie-base-input>
          </div>

          <div class="superuser-import-form__block-content">
            <oie-base-input
              v-model="erpCustomer.mobile"
              :label-text="t('superuserImportMobileLabel')"
              :is-readonly="true"
              class="superuser-import__input-wide"></oie-base-input>
          </div>

          <div class="superuser-import-form__block-content">
            <oie-base-dropdown
              v-model="erpCustomer.language"
              :label-text="tStatic('superUserUserPreferredLanguage')"
              :options="erpCustomer.marketLanguages"
              name="user-language"
              :use-filter-functionality="false">
            </oie-base-dropdown>
          </div>

          <div class="superuser-import-form__block-content">
            <oie-base-radio
              id="erpcust-iscompany"
              v-model="erpCustomer.isCompany"
              name="is-company"
              :value="true"
              :is-checked="erpCustomer.generateEmail"
              css-classes="register-container__radios"
              label-text="Is Company"
              @click="erpCustomer.isCompany = null"></oie-base-radio>

            <oie-base-radio
              id="erpcust-isprivate"
              v-model="erpCustomer.isCompany"
              name="is-company"
              :value="false"
              :is-checked="!erpCustomer.isCompany"
              css-classes="register-container__radio"
              label-text="Is Private"></oie-base-radio>
          </div>

          <div class="superuser-import-from__block-actions">
            <oie-base-button
              v-element-loader="{ endpoint: 'superuser/import' }"
              css-classes="button--with-border button--blue supseruser-import__action"
              :text="t('superuserImportErpCustomerButtonLabel')"
              @click="importErpCustomer()"></oie-base-button>

            <oie-base-button class="button--no-background" :text="t('superuserImportCancelButtonLabel')" @click="hideImportCustomer()"></oie-base-button>
          </div>
        </div>
      </validation-observer>
    </div>

    <div v-if="erpCustomer && (!erpCustomer.hasEmail || !erpCustomer.hasMobile)">
      <h3>{{ t('superuserImportFoundErpCustomerNoEmailHeader') }}</h3>

      <validation-observer
        ref="superuserImportForm"
        tag="form">
        <div class="superuser-import-info__container">
          <div class="superuser-import-form__block-content">
            <oie-base-input
              v-model="erpCustomer.name"
              :label-text="t('superuserImportNameLabel')"
              :is-readonly="true"
              class="superuser-import__input-wide"></oie-base-input>
          </div>

          <div class="superuser-import-form__block-content">
            <oie-base-input
              v-model="erpCustomer.firstName"
              :label-text="tStatic('firstNameLabel')"
              class="superuser-import__input-wide"></oie-base-input>
          </div>

          <div class="superuser-import-form__block-content">
            <oie-base-input
              v-model="erpCustomer.lastName"
              :label-text="tStatic('lastNameLabel')"
              class="superuser-import__input-wide"></oie-base-input>
          </div>

          <div class="superuser-import-form__block-content">
            <oie-base-radio
              id="erpcust-generateemail"
              v-model="erpCustomer.generateEmail"
              name="type-of-email"
              :value="true"
              :is-checked="erpCustomer.generateEmail"
              css-classes="register-container__radios"
              :label-text="t('superuserImportSkipEmailOptionLabel')"
              @click="erpCustomer.email = null"></oie-base-radio>

            <oie-base-radio
              id="erpcust-setemail"
              v-model="erpCustomer.generateEmail"
              name="type-of-email"
              :value="false"
              :is-checked="!erpCustomer.generateEmail"
              css-classes="register-container__radio"
              :label-text="t('superuserImportAssignEmailOptionLabel')"></oie-base-radio>
          </div>

          <div
            v-if="!erpCustomer.generateEmail"
            class="superuser-import-form__block-content">
            <validation-provider v-slot="{errors}" rules="required|email" slim>
              <oie-base-input
                v-model="erpCustomer.email"
                :label-text="`${t('superuserCustomerEmailLabel')}*`"
                class="superuser-import__input-wide"
                :error-messages="errors"></oie-base-input>
            </validation-provider>
          </div>

          <div class="superuser-import-form__block-content">
            <validation-provider v-slot="{errors}" rules="required" slim>
              <oie-base-input
                v-model="erpCustomer.mobile"
                :label-text="`${t('superuserImportMobileLabel')}*`"
                class="superuser-import__input-wide"
                :error-messages="errors"></oie-base-input>
            </validation-provider>
          </div>

          <div class="superuser-import-form__block-content">
            <oie-base-dropdown
              v-model="erpCustomer.language"
              :label-text="tStatic('superUserUserPreferredLanguage')"
              :options="erpCustomer.marketLanguages"
              name="user-language"
              :use-filter-functionality="false">
            </oie-base-dropdown>
          </div>

          <div class="superuser-import-form__block-content">
            <oie-base-radio
              id="erpcust-iscompany"
              v-model="erpCustomer.isCompany"
              name="is-company"
              :value="true"
              :is-checked="erpCustomer.isCompany"
              css-classes="register-container__radios"
              :label-text="t('superuserImportIsCompanyOptionLabel')"
              @click="erpCustomer.isCompany = null"></oie-base-radio>

            <oie-base-radio
              id="erpcust-isprivate"
              v-model="erpCustomer.isCompany"
              name="is-company"
              :value="false"
              :is-checked="!erpCustomer.isCompany"
              css-classes="register-container__radio"
              :label-text="t('superuserImportIsPrivateOptionLabel')"></oie-base-radio>
          </div>

          <div class="superuser-import-from__block-actions">
            <oie-base-button
              v-element-loader="{ endpoint: 'superuser/import' }"
              css-classes="button--with-border button--blue superuser-import__action"
              :text="t('superuserImportErpCustomerButtonLabel')"
              @click="importErpCustomer()"></oie-base-button>

            <oie-base-button class="button--no-background" text="Avbryt" @click="hideImportCustomer()"></oie-base-button>
          </div>
        </div>
      </validation-observer>
    </div>

    <div v-if="erpCustomerImported" class="superuser-import-from__success">
      {{ erpCustomerImported }}
    </div>
  </div>
</template>

<script>
import httpService from '@/core/http-service'

export default {
  data: () => ({
    query: null,
    existingCustomers: null,
    erpCustomer: null,
    erpCustomerImported: null,
    skipClearState: false
  }),
  computed: {
  },
  watch: {
    query() {
      this.clearSearch()
    }
  },
  mounted() {
  },
  methods: {
    async searchCustomer() {
      this.clearSearch()

      const isValid = await this.$refs.superuserImportSearchForm.validate()

      if (!isValid) {
        return
      }

      httpService.post('superuser/import/search', { customerNumbers: [ this.query ] })
        .then(({ data }) => {
          if(!data.success) {
            this.triggerModal(data.message)
          }
          this.existingCustomers = data.existingCustomers
          this.erpCustomer = data.erpCustomers ? data.erpCustomers[0] : null
        }).catch((error) => {
          if (error.response.status === 409) {
            this.$refs.superuserImportSearchForm.setErrors(error.response.data.errors)
          }
        })
    },
    async importErpCustomer() {
      const isValid = await this.$refs.superuserImportForm.validate()

      if (!isValid) {
        return
      }
      httpService.post('superuser/import', [{ customerNumber: this.erpCustomer.customerNumber, email: this.erpCustomer.email, firstName: this.erpCustomer.firstName, lastName: this.erpCustomer.lastName, mobile: this.erpCustomer.mobile, isCompany: this.erpCustomer.isCompany, language: this.erpCustomer.language }])
        .then(({ data }) => {
          this.skipClearState = true
          this.query = null
          this.erpCustomerImported = data.message
          this.$refs.superuserImportSearchForm.reset()
        })
    },
    clearSearch() {
      this.existingCustomers = null
      this.erpCustomer = null
      if (!this.skipClearState) {
        this.erpCustomerImported = null
      } else {
        this.skipClearState = false
      }
    },
    hideImportCustomer() {
      this.query = null
      this.clearSearch()
    },
    triggerModal(message) {
      this.publish('modal.show.generic', {
        header: this.tStatic('superUserWarningMessageHeader'),
        text: message,
        buttons: [ {
          text: this.tStatic('superUserContinueButton'),
          usePrimaryButton: true,
          handler: () => {
            this.publish('modal.hide.generic')
          }
        }]
      })
    }
  }
}
</script>

<style lang="scss">
.superuser-importsearch__top {
  display: flex;
  flex-direction: column;
  margin-bottom: measure(full);

  @include media(medium) {
    flex-direction: row;
  }
}

.superuser-importsearch__form {
  display: flex;
  flex-direction: column;
  width: 100%;
  order: 1;

  @include media(small) {
    flex-direction: row;
    max-width: 30rem;
  }

  @include media(medium) {
    order: initial;
  }
}

.superuser-importsearch__input {
  margin-bottom: measure(quarter);

  @include media(small) {
    margin-bottom: 0;
    margin-right: measure(half);
  }
}

.superuser-importsearch__action {
  width: 100%;

  @include media(small) {
    width: auto;
    min-width: 9rem;
    margin-top: 1.6875rem;
  }
}

.superuser-import-form__block-content {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: measure(half);
  margin-bottom: measure(half);
}

.superuser-import__input-wide {
  max-width: 31rem;
}

.superuser-import__action {
  width: 100%;
  margin-bottom: measure(full);

  @include media(small) {
    width: auto;
    min-width: 9rem;
    margin-top: 1.6875rem;
  }
}

.superuser-import-from__block-actions {
  display: flex;
  align-items: center;
}

.superuser-import-from__success {
  color: color(text-green);
}
</style>
